import { BoxHeaderTitle } from './BoxHeaderTitle';

import { GridHeaderMenuTitle } from '@components/HeaderTitle';

interface IProps {
  Title: string;
}

export const TitleHeaderBox: React.FC<IProps> = ({ Title }) => {
  return (
    <BoxHeaderTitle>
      <GridHeaderMenuTitle>
        <div className="lg:text-2xl md:text-xl text-sm lg:font-black md:font-black font-bold">
          {Title}
        </div>
      </GridHeaderMenuTitle>
    </BoxHeaderTitle>
  );
};
